<template>
    <div>
        <v-layout row wrap>
            <v-flex xs4 v-for="attachment in extra.attachments" class="pl-2">
                <file-display :src="attachment"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "FileAttached",
        props: ['extra', 'days', 'user'],
        components: {FileDisplay}
    }
</script>
